import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-locize-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    fallbackLng: process.env.REACT_APP_LOCIZE_LANGUAGE,
    supportedLngs:
      process.env.REACT_APP_LOCIZE_SUPPORTED_LANGUAGES?.split(',') || undefined,
    debug: process.env.NODE_ENV === 'development',
    load: 'languageOnly',
    ns: ['game'],
    defaultNS: 'game',
    saveMissing: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      projectId: process.env.REACT_APP_LOCIZE_PROJECTID || '',
      apiKey: process.env.REACT_APP_LOCIZE_API_KEY || undefined,
      referenceLng: process.env.REACT_APP_LOCIZE_LANGUAGE,
      version: process.env.REACT_APP_LOCIZE_VERSION || undefined,
    },
    detection: {
      order: ['localStorage', 'querystring', 'navigator'],
    },
  });

export default i18n;
